module.exports = __webpack_public_path__ + "img/ls2.2dd4e4e7.webp";